export default __webpack_public_path__ + "static/media/handshake-light.ff420cb1.mp4";